import Conclave from '../components/conclave';

export default function Qualityconclave() {
  return (
    <Conclave
      geturl="https://cpccbe.org/api/qualityconclave/allmodals"
      createmodel1url="https://cpccbe.org/api/qualityconclave/modal1"
      createmodel2url="https://cpccbe.org/api/qualityconclave/modal2"
      updateurl="https://cpccbe.org/api/qualityconclave/modal"
      deleteurl="https://cpccbe.org/api/qualityconclave/modal"
      head="Quality Conclave"
    />
  );
}
